import {Injectable} from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate, Router, RouterStateSnapshot
} from "@angular/router";
import {AuthService} from "../services/common/auth.service";
import {DemoService} from "../services/common/demo.service";

/**
 * Variante di IsLoggedGuard per le rotte che compongono la superficie della
 * demo pubblica (mappa, veicoli, storico): lascia passare sia l'utente loggato
 * sia quello in sessione demo.
 *
 * Va messo SOLO sulle rotte demo. Tutte le altre restano con IsLoggedGuard e
 * quindi risultano bloccate in demo senza doverle elencare da nessuna parte:
 * una rotta nuova nasce non accessibile in demo, che è il default sicuro.
 */
@Injectable({
  providedIn: 'root'
})
export class DemoOrLoggedGuard implements CanActivate {
  constructor(
    private router: Router,
    private demo: DemoService
  ){}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    if(AuthService.isLogged || DemoService.active) return true;
    this.router.navigate(['/login'], {replaceUrl: true});
    return false;
  }

}
